export default __webpack_public_path__ + "static/media/Nick.2d76e379.jpg";